<template>
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M5.56971 2.04814C5.31595 1.65062 4.68405 1.65062 4.43029 2.04815L3.11117 4.11461C2.98369 4.31431 3.12712 4.57603 3.36404 4.57603H6.63596C6.87287 4.57603 7.0163 4.31431 6.88883 4.11461L5.56971 2.04814ZM7.86843 6.07169C8.03965 6.07169 8.19897 6.15931 8.29067 6.3039L8.95515 7.35162C9.20975 7.75046 8.89297 8.25 8.38545 8.25H1.61455C1.10703 8.25 0.790245 7.75046 1.04484 7.35162L1.71444 6.30266C1.80629 6.15878 1.96519 6.07169 2.13589 6.07169H7.86843Z"
        />
    </svg>
</template>